import { UOM } from "../constants";
import { isEmpty } from "../utils/helpers";

export const convert = ({ input, uomIn, uomOut, gsm, widthInCm, conversionFactorList }) => {
  if (isEmpty(input)) return input;
  if (isEmpty(uomIn) || isEmpty(uomOut)) {
    console.error(`Arguments 'uomIn' and 'uomOut' are required for unit conversion. uomIn = ${uomIn}, uomOut = ${uomOut}`);
    return;
  }
  if (uomIn === uomOut) return input;

  if (uomIn === UOM.KILOGRAM.value || uomIn === UOM.GRAM.value || uomOut === UOM.KILOGRAM.value || uomOut === UOM.GRAM.value) {
    if (uomIn === UOM.GRAM.value && uomOut === UOM.KILOGRAM.value) {
      return input / 1000;
    } else if (uomIn === UOM.KILOGRAM.value && uomOut === UOM.GRAM.value) {
      return input * 1000;
    }

    if (isEmpty(gsm) || isEmpty(widthInCm)) {
      console.error(
        `Cannot convert knit fabric as GSM and/or FinishedWidth is missing. Input Value = ${input}, uomIn = ${uomIn}, uomOut = ${uomOut}, GSM = ${gsm}, widthInCm = ${widthInCm}`
      );
      return;
    }
    // Length (m) x Width (m) x GSM = Weight (KG) * 1000
    // Length (m) = (Weight (KG) * 1000 * 100)/(Width (cm) x GSM)
    // Weight (KG)  = (Length (m) * Width (cm) x GSM)/(1000 * 100)

    if (uomIn === UOM.KILOGRAM.value && uomOut === UOM.METER.value) {
      return (input * 1000 * 100) / (widthInCm * gsm);
    } else if (uomIn === UOM.GRAM.value && uomOut === UOM.METER.value) {
      return (input * 100) / (widthInCm * gsm);
    } else if (uomIn === UOM.KILOGRAM.value && uomOut === UOM.CENTIMETER.value) {
      return (input * 1000 * 100 * 100) / (widthInCm * gsm);
    } else if (uomIn === UOM.GRAM.value && uomOut === UOM.CENTIMETER.value) {
      return (input * 100 * 100) / (widthInCm * gsm);
    } else if (uomIn === UOM.METER.value && uomOut === UOM.KILOGRAM.value) {
      return (input * widthInCm * gsm) / (1000 * 100);
    } else if (uomIn === UOM.METER.value && uomOut === UOM.GRAM.value) {
      return (input * widthInCm * gsm) / 100;
    } else if (uomIn === UOM.CENTIMETER.value && uomOut === UOM.KILOGRAM.value) {
      return (input * widthInCm * gsm) / (1000 * 100 * 100);
    } else if (uomIn === UOM.CENTIMETER.value && uomOut === UOM.GRAM.value) {
      return (input * widthInCm * gsm) / (100 * 100);
    } else {
      console.error(
        `uomIn must be one of - [KG, Gram, Meter, Centimeter] and uomOut must be one of - [KG, Gram, Meter, Centimeter] for knitted fabric conversion.`
      );
      return;
    }
  } else {
    if (isEmpty(conversionFactorList)) {
      console.error(`Arguments 'conversionFactorList' is required for standard unit conversion.`);
      return;
    }
    const stdFactor = conversionFactorList.find(f => uomIn === f.fromUom && uomOut === f.toUom);
    const reverseFactor = conversionFactorList.find(f => uomIn === f.toUom && uomOut === f.fromUom);
    if (isEmpty(stdFactor) && isEmpty(reverseFactor)) {
      console.error(`Conversion Factor for fromUom = ${uomIn}, toUom = ${uomOut} is not registered in the system`);
      return;
    }
    const operation = !isEmpty(stdFactor) ? stdFactor.operation : reverseFactor.operation;
    const factorValue = !isEmpty(stdFactor) ? stdFactor.factorValue : reverseFactor.factorValue;

    if (isEmpty(operation) || !/multiply|divide/i.test(operation)) {
      console.error(`Invalid value for ConversionFactor.operation. Value must be one of: [multiply, divide]. rejectedValue = ${operation}`);
      return;
    }
    if (isEmpty(factorValue) || factorValue === 0.0) {
      console.error(`Conversion Factor Value must be non zero value. rejectedValue = ${factorValue}`);
      return;
    }

    if (!isEmpty(stdFactor)) {
      if ("multiply" === operation.toLowerCase()) {
        return input * factorValue;
      } else if ("divide" === operation.toLowerCase()) {
        return input / factorValue;
      }
    } else {
      if ("multiply" === operation.toLowerCase()) {
        return input / factorValue;
      } else if ("divide" === operation.toLowerCase()) {
        return input * factorValue;
      }
    }
  }
};
